module.exports = __webpack_public_path__ + "media/images/flags/nb-266dbd6fc3e66414aa3c05bb90510bf7.svg";